<template>
  <div>
    <v-view :tableData="tableData" :tableProps="tableProps" :unstyled="false" :modalProps="modalProps"
      :columns="columns" :routes="routes" :initialSort="initialSort" :buttonsVisibility="buttonsVisibility"
      :rowButtonAction="rowButtonAction" v-model:selectedRows="selectedRows">
      <template #crud="formProps">
        <RoleForm :formProps="formProps"> </RoleForm>
      </template>
      <template #search="searchProps">
        <RoleSearch :searchProps="searchProps"> </RoleSearch>
      </template>
    </v-view>
  </div>
</template>

<script setup>
import RoleForm from './RoleForm.vue';
import RoleSearch from './RoleSearch.vue';
import { rowButtonAction } from '@pages/Helper/crud_utils.js';
import { ref } from 'vue';

const props = defineProps({
  tableData: Object,
  tableProps: Object,
  modalProps: Object,
  columns: Object,
  routes: Object,
  initialSort: Object,
  buttonsVisibility: Object,
});

const selectedRows = ref([]);

//------------------------------------------------------------------------------
</script>

<style lang="scss" scoped></style>
